import React from 'react';
import { Icon } from 'semantic-ui-react';
import GlassmorphismTheme from '../../styles/glassmorphism';

const PAGE_BACKGROUND = `linear-gradient(135deg, rgba(230, 230, 250, 0.45), rgba(176, 196, 222, 0.25)), #eef1f8`;

interface GlassPageWrapperProps {
  children: React.ReactNode;
  title?: string;
  icon?: string;
  className?: string;
  /** Preenche a área útil abaixo do header (47px) — usar em páginas de campanha */
  fillViewport?: boolean;
}

const GlassPageWrapper: React.FC<GlassPageWrapperProps> = ({ 
  children, 
  title, 
  icon, 
  className,
  fillViewport = false,
}) => {
  return (
    <div 
      className={className}
      style={{
        background: PAGE_BACKGROUND,
        boxSizing: 'border-box',
        padding: '16px 20px',
        ...(fillViewport
          ? { minHeight: 'calc(100vh - 47px)', width: '100%' }
          : {}),
      }}
    >
      {title && (
        <div style={{
          marginBottom: GlassmorphismTheme.spacing.md,
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          {icon && <Icon name={icon as any} style={{ color: '#667eea' }} />}
          <h1 style={{
            margin: 0,
            color: '#2c3e50',
            fontSize: '1.8rem',
            fontWeight: 600
          }}>
            {title}
          </h1>
        </div>
      )}
      {children}
    </div>
  );
};

export default GlassPageWrapper;
